<script>
	import { scooterStorage } from '../stores/preferences';
	// this is selected page under scooter detail
	export let selected = 'home';
</script>

<!-- refactor take data from response not from storage -->

<div
	class="container mx-auto my-8 border-b border-gray-200 pb-8 text-center md:my-10 md:w-4/5 md:pb-10"
>
	<a href="/skutr-{$scooterStorage?.url}/" class="mb-6">
		<img
			src={$scooterStorage?.image}
			class="mx-auto inline-block w-40"
			alt={"skútr " + $scooterStorage?.producer + " " +
			 $scooterStorage?.name + ", " + $scooterStorage?.ccm + " ccm"}
		/>
	</a>

	<div class="mb-6 text-center">
		<h1 class="text-2xl font-medium sm:text-3xl">
			{$scooterStorage?.producer}
			{$scooterStorage?.name}, {$scooterStorage?.ccm.toString() !== "0" ? 
				$scooterStorage.ccm + ' ccm' : ' elektro'}
		</h1>
	</div>

	<div class="flex flex-col items-center gap-2 whitespace-nowrap md:flex-row md:justify-center">
		<a
			href="/skutr-{$scooterStorage?.url}/"
			class:bg-footer={selected === 'home'}
			class:bg-gray-300={selected !== 'home'}
			class:text-black={selected !== 'home'}
			class:text-white={selected === 'home'}
			class:fill-white={selected === 'home'}
			class="hover:bg-footer transition-all inline-block w-11/12 fill-black p-4 px-8 text-left hover:fill-white hover:text-white md:mb-0 md:w-auto md:text-center"
		>
			<svg
				class="-mt-0.5 mr-2 inline-block w-4"
				xmlns="http://www.w3.org/2000/svg"
				x="0px"
				y="0px"
				viewBox="0 0 14.096 14.075"
				enable-background="new 0 0 14.096 14.075"
				xml:space="preserve"
			>
				<path
					d="M13.605,6.122l-2.307-0.659l1.165-2.097l-1.524-1.524L8.842,3.007L8.183,0.7H6.027L5.368,3.007L3.271,1.842L1.747,3.366 l1.165,2.097L0.605,6.122v2.156l2.307,0.659l-1.165,2.097l1.524,1.524l2.097-1.165L6.027,13.7h2.156l0.659-2.307l2.097,1.165 l1.524-1.524l-1.165-2.097l2.307-0.659V6.122z M7.105,8.925c-0.953,0-1.725-0.772-1.725-1.725s0.772-1.725,1.725-1.725 c0.952,0,1.725,0.772,1.725,1.725S8.058,8.925,7.105,8.925z"
				/>
			</svg>
			Náhradní díly
		</a>
		<a
			href="/skutr-{$scooterStorage?.url}/technicke-udaje/"
			class:bg-footer={selected === 'technicke-udaje'}
			class:bg-gray-300={selected !== 'technicke-udaje'}
			class:text-black={selected !== 'technicke-udaje'}
			class:text-white={selected === 'technicke-udaje'}
			class:fill-white={selected === 'technicke-udaje'}
			class="hover:bg-footer transition-all inline-block w-11/12 fill-black p-4 px-8 text-left hover:fill-white hover:text-white md:mb-0 md:w-auto md:text-center"
		>
			<svg
				class="-mt-0.5 mr-2 inline-block w-4"
				xmlns="http://www.w3.org/2000/svg"
				x="0px"
				y="0px"
				viewBox="0 0 14.948 14.075"
				enable-background="new 0 0 14.948 14.075"
				xml:space="preserve"
			>
				<g>
					<rect x="0.437" y="0.539" width="14" height="4" />
					<rect x="0.437" y="5.539" width="10" height="2" />
					<rect x="0.437" y="8.539" width="14" height="2" />
					<rect x="0.437" y="11.539" width="6" height="2" />
				</g>
			</svg>
			Technické parametry
		</a>
		{#if $scooterStorage.hasGraphs}
			<a
				href="/skutr-{$scooterStorage?.url}/zvyseni-vykonu/"
				class:bg-footer={selected === 'zvyseni-vykonu'}
				class:bg-gray-300={selected !== 'zvyseni-vykonu'}
				class:text-black={selected !== 'zvyseni-vykonu'}
				class:text-white={selected === 'zvyseni-vykonu'}
				class:fill-white={selected === 'zvyseni-vykonu'}
				class="hover:bg-footer transition-all inline-block w-11/12 bg-gray-300 fill-black p-4 px-8 text-left text-black hover:fill-white hover:text-white md:mb-0 md:w-auto md:text-center"
			>
				<svg
					class="-mt-0.5 mr-2 inline-block w-4"
					xmlns="http://www.w3.org/2000/svg"
					x="0px"
					y="0px"
					viewBox="0 0 14.948 14.075"
					enable-background="new 0 0 14.948 14.075"
					xml:space="preserve"
				>
					<g>
						<rect x="10.295" y="0.582" width="4" height="13" />
						<rect x="5.295" y="4.582" width="4" height="9" />
						<rect x="0.295" y="8.582" width="4" height="5" />
					</g>
				</svg>
				Zvýšení výkonu
			</a>
		{/if}
		{#if $scooterStorage.hasArticles}
			<a
				href="/skutr-{$scooterStorage?.url}/blog/"
				class:bg-footer={selected === 'blog'}
				class:bg-gray-300={selected !== 'blog'}
				class:text-black={selected !== 'blog'}
				class:text-white={selected === 'blog'}
				class:fill-white={selected === 'blog'}
				class="hover:bg-footer transition-all inline-block w-11/12 bg-gray-300 fill-black p-4 px-8 text-left text-black hover:fill-white hover:text-white md:mb-0 md:w-auto md:text-center"
			>
				<svg
					class="-mt-0.5 mr-2 inline-block w-4"
					xmlns="http://www.w3.org/2000/svg"
					x="0px"
					y="0px"
					viewBox="0 0 14.948 14.075"
					enable-background="new 0 0 14.948 14.075"
					xml:space="preserve"
				>
					<path
						d="M10.231,1.18L1.948,9.463l0,0l0,0l-0.97,3.921c-0.022,0.09,0.059,0.172,0.15,0.15l3.921-0.97l0,0l0,0l8.283-8.283 c0.856-0.856,0.856-2.245,0-3.101C12.476,0.323,11.087,0.323,10.231,1.18z"
					/>
				</svg>
				Články a tipy
			</a>
		{/if}
	</div>
</div>
